import { classnames } from 'Utils/classnames/classnames.utils';

import { COLORS, COMPLEMENTARY_COLORS } from 'Components/utils/color/colors';

export const themes = {
  default: ({ color = COLORS.LIGHT_SAND, isDisabled }) => ({
    thRoot: classnames(
      'flex aspect-square h-46 items-center justify-center rounded-full text-12 leading-0 transition-colors duration-250 ease-in',
      {
        [`bg-${color} hocus:bg-${color}-active text-${COMPLEMENTARY_COLORS[color]} hocus:text-${COMPLEMENTARY_COLORS[color]}-active`]:
          !isDisabled,
        'bg-pearl text-grey': isDisabled,
      },
    ),
  }),
  ghost: ({ color = COLORS.TRANSPARENT, isDisabled }) => ({
    thRoot: classnames(
      'flex aspect-square h-46 items-center justify-center rounded-full text-12 leading-0 transition-colors duration-250 ease-in',
      {
        [`bg-transparent hocus:bg-${color} text-black hocus:text-${COMPLEMENTARY_COLORS[color]}`]:
          !isDisabled,
        'bg-transparent text-grey': isDisabled,
      },
    ),
  }),
};
